import { useWorkspaces } from '../../lib/workspaces';
import { RoutinesSummary } from './routines/RoutinesSummary';
import { TasksSummary } from './tasks/TasksSummary';
import { FilesSummaryCard } from './agents/FilesSummaryCard';
import { AppsSummaryCard } from './agents/AppsSummaryCard';
import styles from './WorkspaceSummaryRow.module.css';

// The four summary tiles — Routines · Tasks · Files · Apps — scoped to one Space, at the head of its
// Dashboard tab. THE SAME components Your Agents renders account-wide, given a `workspaceId`, rather
// than a second per-workspace implementation: the two surfaces answering the same question differently
// is exactly the drift the merge of "Agents at work" into Dashboard was meant to end.
//
// Each tile links to its own screen pre-filtered to this Space, so the drill-in never widens the scope
// the reader is already in.
export function WorkspaceSummaryRow({ slug, page }: { slug: string; page: string }) {
  const workspaces = useWorkspaces();
  const workspace = workspaces.status === 'ready' ? workspaces.workspaces.find((w) => w.slug === slug) : undefined;
  // Until the roster resolves there is no id to scope by, and an unscoped read here would briefly show
  // the ACCOUNT's counts inside a Space — a wrong number is worse than a late one.
  if (!workspace) return null;
  return (
    <div className={styles.row}>
      <RoutinesSummary workspaceId={workspace.id} workspaceSlug={workspace.slug} pageName={page} />
      <TasksSummary workspaceId={workspace.id} workspaceSlug={workspace.slug} pageName={page} />
      <FilesSummaryCard workspaceId={workspace.id} workspaceSlug={workspace.slug} pageName={page} />
      <AppsSummaryCard workspaceId={workspace.id} workspaceSlug={workspace.slug} pageName={page} />
    </div>
  );
}
